const isUserMentionable = (user, currentUserId, laymanMode) => {
  const { id, isCustomer } = user;

  if (id !== currentUserId) {
    return true;
  }

  return laymanMode ? !isCustomer : isCustomer;
};

const getMentionsList = (roomUsers, currentUserId, laymanMode) => {
  const mentionsList = [
    ...roomUsers
      .filter(user => isUserMentionable(user, currentUserId, laymanMode))
      .map(({ id, name }) => ({
        id: `${name}+${id}`,
        display: name,
      })),
    { id: 'channel+0', display: 'channel' },
  ];

  return mentionsList;
};

export default getMentionsList;
